import api from './api';

export const kbApi = {
  list: (params) => api.get('/api/kb', { params }),
  get: (id) => api.get(`/api/kb/${id}`),
  create: (data) => api.post('/api/kb', data),
  update: (id, data) => api.put(`/api/kb/${id}`, data),
  delete: (id) => api.delete(`/api/kb/${id}`),
};
